module.exports = "/wp-content/themes/onnit/script/cart/dist/vtiOverride-4dc43ad8.png";